import Title from './Title';
export { Title };
export default Title;
